"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = KevelPLPBanner;
const react_1 = __importDefault(require("react"));
const DuplexBanner_1 = __importDefault(require("./DuplexBanner/DuplexBanner"));
const ImageBanner_1 = __importDefault(require("./ImageBanner/ImageBanner"));
function KevelPLPBanner(props) {
    const isDefaultDuplexBanner = !props.designType &&
        (props.esiType === "browse-v2" || props.esiType === "search-v2");
    if (props.designType === "Image" || props.designType === "PremiumImage") {
        return react_1.default.createElement(ImageBanner_1.default, Object.assign({}, props));
    }
    if (props.designType === "Duplex" ||
        props.designType === "PremiumDuplex" ||
        isDefaultDuplexBanner) {
        return react_1.default.createElement(DuplexBanner_1.default, Object.assign({}, props));
    }
    return null;
}
